import { SipAssignmentStatus } from "../../model/sipAssignmentStatus";
import { asSelectOptions, SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipAssignmentStatus;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getSipAssignmentStatuses(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(
      apiUrls.getSipAssignmentStatuses
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = asSelectOptions({
        data: response.data,
        doFilter: true,
      });
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error fetching sipAssignmentStatuses:", err);
    return { error: (err as Error).message };
  }
}
